module.exports = __webpack_public_path__ + "media/images/front/banner_seminar20181118-9ccaebfe2bdae4697827b67f5eea4f80.jpg";